import { ContentContainer } from '../../components/ContentContainer';
import { SimpleVenueMap } from '../../components/SimpleVenueMap';
import { formatDisplayUrl } from '../../lib/formatUrl';
import type { WineryContactLocationProps } from './types';

export const WineryContactLocation = ({ venue }: WineryContactLocationProps) => {
  return (
    <ContentContainer>
      <h2 className="text-xl font-semibold text-gray-900 mb-4">Contact & Location</h2>

      {/* Address and Contact Details */}
      <div className="space-y-2 text-gray-700 mb-6">
        <div>
          <span className="font-medium">Address:</span> {venue.address.street},{' '}
          {venue.address.city}, {venue.address.state} {venue.address.zipCode}
        </div>
        <div>
          <span className="font-medium">Phone:</span>{' '}
          {venue.phone ? (
            venue.phone
          ) : (
            <span className="text-gray-400 italic">Unknown</span>
          )}
        </div>
        <div>
          <span className="font-medium">Email:</span>{' '}
          {venue.email ? (
            <a href={`mailto:${venue.email}`} className="text-primary-600 hover:underline">
              {venue.email}
            </a>
          ) : (
            <span className="text-gray-400 italic">Unknown</span>
          )}
        </div>
        <div>
          <span className="font-medium">Website:</span>{' '}
          {venue.website ? (
            <a
              href={venue.website}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-600 hover:underline"
            >
              {formatDisplayUrl(venue.website)}
            </a>
          ) : (
            <span className="text-gray-400 italic">Unknown</span>
          )}
        </div>
      </div>

      {/* Location Map */}
      <div className="h-80 md:h-96 rounded-lg overflow-hidden">
        <SimpleVenueMap
          venue={{
            id: venue._id,
            name: venue.name,
            coordinates: venue.address.coordinates,
            address: venue.address,
          }}
          className="w-full h-full"
        />
      </div>
    </ContentContainer>
  );
};
